import { NativeModulesProxy } from '@unimodules/core';
export default NativeModulesProxy.ExpoInAppPurchases;
